import { render, staticRenderFns } from "./JISTRDRCT.vue?vue&type=template&id=ba77586a"
import script from "./JISTRDRCTController.ts?vue&type=script&lang=ts&external"
export * from "./JISTRDRCTController.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports